module.exports = __webpack_public_path__ + "static/img/logo.a1cac6b5.svg";